import { render, staticRenderFns } from "./FullWidth.vue?vue&type=template&id=fb869e22&scoped=true&"
import script from "./FullWidth.vue?vue&type=script&lang=js&"
export * from "./FullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb869e22",
  null
  
)

export default component.exports